import React from 'react';
import { IProgram, IProgramListProps, ISelectableModuleTile } from '../../../interfaces/interfaces';
import Accordion from '../Accordion/Accordion';
import ProgramListItem from './ProgramListItem';

function List(props: IProgramListProps): JSX.Element {
  const { onItemChange, useGrouping, programGroups } = props;

  const onChange = (item: ISelectableModuleTile, isChecked: boolean) => {
    if (onItemChange) {
      onItemChange(item, isChecked);
    }
  };

  const sortByTitle = (a: IProgram, b: IProgram) => {
    return a.title < b.title ? -1 : 1;
  };

  if (useGrouping) {
    return (
      <ul className="item-list program-group-item-list">
        {programGroups?.map((group) => {
          return (
            <li key={group.id} className="item-list-item">
              <Accordion
                title={group.title}
                contentCount={group.programs?.length || 0}
                className="product-group-accordion"
                openerClassName="product-group-opener"
              >
                <ul className="item-list program-item-list">
                  {(group.programs || []).sort(sortByTitle).map((item) => {
                    return <ProgramListItem key={item.id} item={item} onChange={onChange} />;
                  })}
                </ul>
              </Accordion>
            </li>
          );
        })}
      </ul>
    );
  }

  const allPrograms = (programGroups || [])
    .map((g) => {
      return g.programs;
    })
    .flat();

  allPrograms.sort(sortByTitle);

  return (
    <ul className="item-list program-item-list">
      {allPrograms.map((item) => {
        return <ProgramListItem key={item.id} item={item} onChange={onChange} />;
      })}
    </ul>
  );
}
export default List;
